import { render, staticRenderFns } from "./NotFound404.vue?vue&type=template&id=298dc027&scoped=true&"
import script from "./NotFound404.vue?vue&type=script&lang=ts&"
export * from "./NotFound404.vue?vue&type=script&lang=ts&"
import style0 from "./NotFound404.vue?vue&type=style&index=0&id=298dc027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298dc027",
  null
  
)

export default component.exports